import { runtimeEnv } from '../../config/runtimeEnv';
import SuperAdminDashboardIframePage from './SuperAdminDashboardIframePage';

const SuperAdminBullboardPage = () => {
  return (
    <SuperAdminDashboardIframePage
      title='Bullboard'
      links={[
        { label: 'Sportsbook', url: runtimeEnv.superAdminBullboardUrl },
        { label: 'CRM', url: runtimeEnv.superAdminBullboardCrmUrl },
      ]}
    />
  );
};

export default SuperAdminBullboardPage;
